/**
 * created by yxy
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import HoldAll from './HoldAll';

export default class HoldAllDome extends Component {
    static defaultProps = {};
    static propTypes = {};
    constructor(props) {
        super(props);
        this.state = {
            targetKeys:[],
            treeData:[
                { key: '1', title: '1' },
                {
                    key: '2',
                    title: '2',
                    children: [{ key: '2-1', title: '2-1' }, { key: '2-2', title: '2-2' }],
                },
                { key: '3', title: '3' },
                {
                    key: '4',
                    title: '4',
                    children: [{ key: '4-1', title: '4-1' }, { key: '4-2', title: '4-2' }],
                },
            ],


        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <HoldAll treeData={this.state.treeData} targetKeys={this.state.targetKeys} onChange={this.change}></HoldAll>
            </div>
        )

    }
    change= targetKeys =>{
        console.log('Target Keys:', targetKeys);
        this.setState({ targetKeys });
    }
}